// Master list showing top-level projects/tasks.
import { Box, Typography } from '@mui/material';
import TaskList from '@/features/tasks/components/lists/TaskList';
import { AddTaskRow } from '@/components/ui/AddTaskRow';
import { useT } from '@/i18n/useT';

const ROOT_SX = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100%',
};

const EMPTY_SX = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  color: 'text.secondary',
  p: 3,
  minHeight: 160,
};

const OrganizeMasterList = ({
  tasks,
  selectedTaskIds,
  onSelectionChange,
  duplicateOrderKeyTaskIds,
  itemView,
  plannedParentIds,
  waitingForParentIds,
  tabKey = 'active',
  hasActiveFilter = false,
}) => {
  const t = useT();
  const showEmptyMessage = !tasks || tasks.length === 0;
  const hasSelectedTask = selectedTaskIds?.length > 0;

  let emptyMessage;
  if (hasActiveFilter) {
    emptyMessage = t('organize.noTasks', 'No tasks match the current filters.');
  } else if (tabKey === 'backlog') {
    emptyMessage = t('organize.emptyBacklog', 'Nothing in Backlog.');
  } else {
    emptyMessage = t('organize.emptyActive', 'No active tasks.');
  }

  return (
    <Box sx={ROOT_SX}>
      <TaskList
        id="master-list"
        listId="organize-master-list"
        isSortable={true}
        tasks={tasks}
        selectedTaskIds={selectedTaskIds}
        onSelectionChange={onSelectionChange}
        duplicateOrderKeyTaskIds={duplicateOrderKeyTaskIds}
        view={itemView}
        menuSurface="organize-master"
        plannedParentIds={plannedParentIds}
        waitingForParentIds={waitingForParentIds}
        listTabIndex={tasks?.length > 0 ? 0 : -1}
        itemTabIndex={-1}
      />

      {showEmptyMessage ? (
        <Box
          data-testid="organize-master-empty-state"
          sx={EMPTY_SX}
        >
          <Typography variant="body1" color="text.secondary">
            {emptyMessage}
          </Typography>
        </Box>
      ) : null}
      <AddTaskRow
        tasks={tasks}
        tabIndex={hasSelectedTask ? -1 : 0}
      />
    </Box>
  );
};

export default OrganizeMasterList;
